<template>
  <v-dialog
    ref="dialog"
    v-model="menu"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        class="custom-datepicker"
        placeholder="- Start Date -"
        v-model="dateRangeText"
        readonly
        v-bind="attrs"
        v-on="on"
        outlined
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" scrollable range>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnCancel')}} </v-btn>
      <v-btn text color="primary" @click="clickOk()"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnOk')}} </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
export default {
    name: 'CustomDateRangePicker',
    props: {
        value: Array
    },
    data: function () {
        return {
            menu: false,
            modal: false,
            date: []
        }
    },
    computed: {
        dateRangeText: function () {
            return this.date.map(o => this.formatDate(o)).join(' - ')
        }
    },
    created: function () {
        this.date = this.value
    },
    methods: {
        clickOk: function () {
            this.$refs.dialog.save(this.date)
            this.$emit('input', this.date)
            this.$emit('onChangeDate', this.date)
        },
        formatDate: function (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${parseInt(year) + 543}`
        }
    }
}
</script>
